module.exports = __webpack_public_path__ + "img/payment-twint.adb933b.svg";